import React from 'react';
import { FloatLabel } from "primereact/floatlabel";
import { Dropdown as DropdownP } from "primereact/dropdown";

const Dropdown = ({
    id,
    filter,
    filterBy,
    name,
    value,
    onChange,
    onBlur,
    options,
    optionLabel,
    optionValue,
    label,
    showClear = false,
    error,
    touched,
    required = false,
    valueTemplate,
    itemTemplate,
    className = "",
    disabled = false,
    ...props
}) => {
    // FloatLabel'ın tutarlı davranması için null değerini undefined'a dönüştür
    const normalizedValue = value === null ? undefined : value;

    // Value var mı kontrolü - label pozisyonu için
    const hasValue = normalizedValue !== undefined && normalizedValue !== null && normalizedValue !== '';

    return (
        <>
            <style jsx>{`
                /* FloatLabel Container - InputText ile tutarlı */
                .custom-dropdown-container .p-float-label {
                    width: 100%;
                    position: relative;
                    margin: 0 !important;
                    padding: 0 !important;
                }

                /* Dropdown Container */
                .custom-dropdown-container .p-dropdown {
                    width: 100% !important;
                    background-color: white !important;
                    border: 2px solid rgb(220, 220, 220) !important;
                    border-radius: 0.5rem !important;
                    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06) !important;
                    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
                    margin: 0 !important;
                    position: relative;
                    min-height: 3.5rem !important;
                }

                /* Dropdown Input Field */
                .custom-dropdown-container .p-dropdown .p-dropdown-label {
                    width: 100% !important;
                    padding: 0.75rem 2.5rem 0.75rem 0.75rem !important;
                    font-size: 1rem !important;
                    line-height: 1.25 !important;
                    background-color: transparent !important;
                    color: black !important;
                    border: none !important;
                    outline: none !important;
                    margin: 0 !important;
                    min-height: 2rem !important;
                    display: flex !important;
                    align-items: center !important;
                }

                /* Focus States */
                .custom-dropdown-container .p-dropdown:not(.p-disabled).p-focus,
                .custom-dropdown-container .p-dropdown:not(.p-disabled):focus-within {
                    border-color: rgb(107, 114, 128) !important;
                    box-shadow: 0 0 0 1px rgb(107, 114, 128), 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06) !important;
                }

                /* Hover States */
                .custom-dropdown-container .p-dropdown:not(.p-disabled):hover {
                    border-color: rgb(156, 163, 175) !important;
                }

                /* Error States */
                .custom-dropdown-container .p-dropdown.p-invalid {
                    border-color: #dc3545 !important;
                    box-shadow: 0 0 0 1px #dc3545, 0 4px 6px -1px rgba(220, 53, 69, 0.1) !important;
                }

                /* Disabled States */
                .custom-dropdown-container .p-dropdown.p-disabled {
                    background-color: rgb(245, 245, 245) !important;
                    border-color: rgb(220, 220, 220) !important;
                    cursor: not-allowed !important;
                    opacity: 0.6 !important;
                }

                .custom-dropdown-container .p-dropdown.p-disabled .p-dropdown-label {
                    color: rgb(156, 163, 175) !important;
                }

                /* Dropdown Trigger (Arrow) */
                .custom-dropdown-container .p-dropdown .p-dropdown-trigger {
                    position: absolute !important;
                    top: 0 !important;
                    right: 0 !important;
                    width: 2.5rem !important;
                    height: 100% !important;
                    display: flex !important;
                    align-items: center !important;
                    justify-content: center !important;
                    color: rgb(107, 114, 128) !important;
                    transition: color 0.2s ease !important;
                    border: none !important;
                    background: transparent !important;
                    cursor: pointer !important;
                    z-index: 1 !important;
                }

                .custom-dropdown-container .p-dropdown:not(.p-disabled):hover .p-dropdown-trigger {
                    color: rgb(75, 85, 99) !important;
                }

                .custom-dropdown-container .p-dropdown.p-disabled .p-dropdown-trigger {
                    color: rgb(156, 163, 175) !important;
                    cursor: not-allowed !important;
                }

                /* Clear Icon */
                .custom-dropdown-container .p-dropdown .p-dropdown-clear-icon {
                    position: absolute !important;
                    top: 64% !important;
                    right: 2.5rem !important;
                    transform: translateY(-50%) !important;
                    color: rgb(107, 114, 128) !important;
                    transition: color 0.2s ease !important;
                    cursor: pointer !important;
                    font-size: 14px !important;
                    z-index: 2 !important;
                }

                .custom-dropdown-container .p-dropdown .p-dropdown-clear-icon:hover {
                    color: rgb(75, 85, 99) !important;
                }

                /* FloatLabel - Default Position */
                .custom-dropdown-container .p-float-label label {
                    position: absolute !important;
                    left: 0.75rem !important;
                    top: 50% !important;
                    transform: translateY(-50%) !important;
                    color: rgb(75, 85, 99) !important;
                    transition: all 0.15s cubic-bezier(0.4, 0, 0.2, 1) !important;
                    font-weight: 500 !important;
                    font-size: 1rem !important;
                    pointer-events: none !important;
                    background: transparent !important;
                    margin: 0 !important;
                    padding: 0 !important;
                    z-index: 1 !important;
                }

                /* Active/Focused Label - Değer varken veya focus olduğunda yukarıda kalması için güçlü selector'lar */
                .custom-dropdown-container .p-float-label .p-dropdown:focus-within ~ label,
                .custom-dropdown-container .p-float-label .p-dropdown.p-focus ~ label,
                .custom-dropdown-container.has-value .p-float-label label,
                .custom-dropdown-container .p-float-label .p-dropdown-label:not(.p-placeholder) ~ label {
                    top: -0.9rem !important;
                    left: 0.5rem !important;
                    transform: translateY(0) !important;
                    font-size: 0.75rem !important;
                    background: transparent !important;
                    padding: 0 !important;
                    border-radius: 0 !important;
                    color: rgb(107, 114, 128) !important;
                    font-weight: 600 !important;
                    z-index: 2 !important;
                }

                /* Placeholder */
                .custom-dropdown-container .p-dropdown-label.p-placeholder {
                    color: rgb(156, 163, 175) !important;
                    font-style: italic !important;
                    opacity: 1 !important;
                }

                /* Selected Value Label */
                .custom-dropdown-container .p-dropdown-label:not(.p-placeholder) {
                    color: black !important;
                    font-weight: 400 !important;
                }

                /* === DROPDOWN PANEL === */
                .p-dropdown-panel {
                    background-color: white !important;
                    border: 1px solid rgb(220, 220, 220) !important;
                    border-radius: 0.5rem !important;
                    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05) !important;
                    margin-top: 0.25rem !important;
                    overflow: hidden !important;
                    z-index: 1000 !important;
                    max-width: var(--dropdown-width) !important;
                    width: var(--dropdown-width) !important;
                    left: var(--dropdown-left) !important;
                    max-height: 250px !important;
                }

                .custom-dropdown-container {
                    --dropdown-width: 100%;
                    --dropdown-left: 0;
                }

                .p-dropdown-panel:has(.p-dropdown-filter-container) {
                    max-height: 320px !important;
                }

                /* Dropdown Items Wrapper */
                .p-dropdown-items-wrapper {
                    max-height: 200px !important;
                    overflow-y: auto !important;
                }

                .p-dropdown-panel:has(.p-dropdown-filter-container) .p-dropdown-items-wrapper {
                    max-height: 260px !important;
                }

                /* Custom Scrollbar */
                .p-dropdown-items-wrapper::-webkit-scrollbar {
                    width: 6px !important;
                }

                .p-dropdown-items-wrapper::-webkit-scrollbar-track {
                    background: rgb(245, 245, 245) !important;
                    border-radius: 3px !important;
                }

                .p-dropdown-items-wrapper::-webkit-scrollbar-thumb {
                    background: rgb(209, 213, 219) !important;
                    border-radius: 3px !important;
                    transition: background-color 0.2s ease !important;
                }

                .p-dropdown-items-wrapper::-webkit-scrollbar-thumb:hover {
                    background: rgb(156, 163, 175) !important;
                }

                /* Dropdown Items */
                .p-dropdown-items {
                    background-color: white !important;
                    padding: 0.25rem !important;
                }

                .p-dropdown-item {
                    color: black !important;
                    padding: 0.75rem !important;
                    border-radius: 0.375rem !important;
                    margin: 0.125rem 0 !important;
                    transition: all 0.2s ease !important;
                    cursor: pointer !important;
                    font-size: 0.875rem !important;
                    line-height: 1.25 !important;
                }

                .p-dropdown-item:hover {
                    background-color: rgb(245, 245, 245) !important;
                    color: rgb(75, 85, 99) !important;
                }

                .p-dropdown-item.p-highlight {
                    background-color: rgb(59, 130, 246) !important;
                    color: white !important;
                }

                .p-dropdown-item.p-highlight:hover {
                    background-color: rgb(37, 99, 235) !important;
                }

                /* Filter Container */
                .p-dropdown-filter-container {
                    padding: 0.5rem !important;
                    border-bottom: 1px solid rgb(229, 231, 235) !important;
                    background-color: rgb(249, 250, 251) !important;
                    position: relative !important;
                }

                :root.dark .p-dropdown-header {
                background-color: rgb(31, 41, 55) !important;
                }

                /* Filter Input */
                .p-dropdown-filter {
                    width: 100% !important;
                    padding: 0.5rem 2rem 0.5rem 0.75rem !important;
                    border: 1px solid rgb(209, 213, 219) !important;
                    border-radius: 0.375rem !important;
                    font-size: 0.875rem !important;
                    background-color: white !important;
                    color: black !important;
                    transition: all 0.2s ease !important;
                    outline: none !important;
                }

                .p-dropdown-filter:focus {
                    border-color: rgb(59, 130, 246) !important;
                    box-shadow: 0 0 0 1px rgb(59, 130, 246) !important;
                }

                .p-dropdown-filter::placeholder {
                    color: rgb(156, 163, 175) !important;
                }

                /* Filter Icon */
                .p-dropdown-filter-icon {
                    position: absolute !important;
                    right: 2rem !important;
                    top: 64% !important;
                    transform: translateY(-50%) !important;
                    color: rgb(107, 114, 128) !important;
                    font-size: 0.875rem !important;
                    pointer-events: none !important;
                }

                /* Empty Message */
                .p-dropdown-empty-message {
                    padding: 1rem !important;
                    color: rgb(107, 114, 128) !important;
                    text-align: center !important;
                    font-size: 0.875rem !important;
                    font-style: italic !important;
                }

                /* === DARK MODE === */
                :root.dark .custom-dropdown-container .p-dropdown {
                    background-color: rgb(31, 41, 55) !important;
                    border-color: rgb(75, 85, 99) !important;
                    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.2), 0 2px 4px -1px rgba(0, 0, 0, 0.12) !important;
                }

                :root.dark .custom-dropdown-container .p-dropdown .p-dropdown-label {
                    color: white !important;
                }

                :root.dark .custom-dropdown-container .p-dropdown:not(.p-disabled).p-focus,
                :root.dark .custom-dropdown-container .p-dropdown:not(.p-disabled):focus-within {
                    border-color: rgb(156, 163, 175) !important;
                    box-shadow: 0 0 0 1px rgb(156, 163, 175), 0 4px 6px -1px rgba(0, 0, 0, 0.2), 0 2px 4px -1px rgba(0, 0, 0, 0.12) !important;
                }

                :root.dark .custom-dropdown-container .p-dropdown:not(.p-disabled):hover {
                    border-color: rgb(107, 114, 128) !important;
                }

                :root.dark .custom-dropdown-container .p-dropdown.p-invalid {
                    border-color: #ff6b6b !important;
                    box-shadow: 0 0 0 1px #ff6b6b, 0 4px 6px -1px rgba(255, 107, 107, 0.2) !important;
                }

                :root.dark .custom-dropdown-container .p-dropdown.p-disabled {
                    background-color: rgb(55, 65, 81) !important;
                    border-color: rgb(75, 85, 99) !important;
                }

                :root.dark .custom-dropdown-container .p-dropdown.p-disabled .p-dropdown-label {
                    color: rgb(107, 114, 128) !important;
                }

                /* Dark Mode - Dropdown Trigger */
                :root.dark .custom-dropdown-container .p-dropdown .p-dropdown-trigger {
                    color: rgb(156, 163, 175) !important;
                }

                :root.dark .custom-dropdown-container .p-dropdown:not(.p-disabled):hover .p-dropdown-trigger {
                    color: rgb(209, 213, 219) !important;
                }

                :root.dark .custom-dropdown-container .p-dropdown.p-disabled .p-dropdown-trigger {
                    color: rgb(107, 114, 128) !important;
                }

                /* Dark Mode - Clear Icon */
                :root.dark .custom-dropdown-container .p-dropdown .p-dropdown-clear-icon {
                    color: rgb(156, 163, 175) !important;
                }

                :root.dark .custom-dropdown-container .p-dropdown .p-dropdown-clear-icon:hover {
                    color: rgb(209, 213, 219) !important;
                }

                /* Dark Mode - FloatLabel */
                :root.dark .custom-dropdown-container .p-float-label label {
                    color: rgb(156, 163, 175) !important;
                }

                /* Dark Mode Active Labels */
                :root.dark .custom-dropdown-container .p-float-label .p-dropdown:focus-within ~ label,
                :root.dark .custom-dropdown-container .p-float-label .p-dropdown.p-focus ~ label,
                :root.dark .custom-dropdown-container.has-value .p-float-label label,
                :root.dark .custom-dropdown-container .p-float-label .p-dropdown-label:not(.p-placeholder) ~ label {
                    background: transparent !important;
                    color: rgb(156, 163, 175) !important;
                    padding: 0 !important;
                    border-radius: 0 !important;
                }

                /* Dark Mode - Placeholder */
                :root.dark .custom-dropdown-container .p-dropdown-label.p-placeholder {
                    color: rgb(107, 114, 128) !important;
                }

                /* Dark Mode - Selected Value */
                :root.dark .custom-dropdown-container .p-dropdown-label:not(.p-placeholder) {
                    color: white !important;
                }

                /* Dark Mode - Dropdown Panel */
                :root.dark .p-dropdown-panel {
                    background-color: rgb(31, 41, 55) !important;
                    border-color: rgb(75, 85, 99) !important;
                    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.3), 0 4px 6px -2px rgba(0, 0, 0, 0.2) !important;
                }

                :root.dark .p-dropdown-items {
                    background-color: rgb(31, 41, 55) !important;
                }

                :root.dark .p-dropdown-item {
                    color: white !important;
                }

                :root.dark .p-dropdown-item:hover {
                    background-color: rgb(55, 65, 81) !important;
                    color: white !important;
                }

                :root.dark .p-dropdown-item.p-highlight {
                    background-color: rgb(59, 130, 246) !important;
                    color: white !important;
                }

                :root.dark .p-dropdown-item.p-highlight:hover {
                    background-color: rgb(37, 99, 235) !important;
                }

                /* Dark Mode - Filter */
                :root.dark .p-dropdown-filter-container {
                    background-color: rgb(55, 65, 81) !important;
                    border-color: rgb(75, 85, 99) !important;
                }

                :root.dark .p-dropdown-filter {
                    background-color: rgb(31, 41, 55) !important;
                    border-color: rgb(75, 85, 99) !important;
                    color: white !important;
                }

                :root.dark .p-dropdown-filter:focus {
                    border-color: rgb(59, 130, 246) !important;
                    box-shadow: 0 0 0 1px rgb(59, 130, 246) !important;
                }

                :root.dark .p-dropdown-filter::placeholder {
                    color: rgb(107, 114, 128) !important;
                }

                :root.dark .p-dropdown-filter-icon {
                    color: rgb(156, 163, 175) !important;
                }

                :root.dark .p-dropdown-empty-message {
                    color: rgb(156, 163, 175) !important;
                }

                /* Dark Mode - Scrollbar */
                :root.dark .p-dropdown-items-wrapper::-webkit-scrollbar-track {
                    background: rgb(55, 65, 81) !important;
                }

                :root.dark .p-dropdown-items-wrapper::-webkit-scrollbar-thumb {
                    background: rgb(75, 85, 99) !important;
                }

                :root.dark .p-dropdown-items-wrapper::-webkit-scrollbar-thumb:hover {
                    background: rgb(107, 114, 128) !important;
                }

                /* Error Message Styling */
                .p-error {
                    color: #dc3545 !important;
                    font-size: 9px !important;
                    font-weight: 500 !important;
                    margin-top: 0.25rem !important;
                    display: block !important;
                    text-align: right !important;
                }

                :root.dark .p-error {
                    color: #ff6b6b !important;
                }

                /* === RESPONSIVE === */
                @media screen and (max-width: 768px) {
                    .custom-dropdown-container .p-dropdown {
                        min-height: 3.25rem !important;
                    }

                    .custom-dropdown-container .p-dropdown .p-dropdown-label {
                        font-size: 16px !important;
                        padding: 0.75rem 2.5rem 0.75rem 0.75rem !important;
                        min-height: 1.75rem !important;
                    }

                    .custom-dropdown-container .p-float-label label {
                        font-size: 16px !important;
                    }

                    .custom-dropdown-container .p-float-label .p-dropdown:focus-within ~ label,
                    .custom-dropdown-container .p-float-label .p-dropdown.p-focus ~ label,
                    .custom-dropdown-container.has-value .p-float-label label,
                    .custom-dropdown-container .p-float-label .p-dropdown-label:not(.p-placeholder) ~ label {
                        font-size: 12px !important;
                        top: -0.9rem !important;
                    }

                    .p-dropdown-panel {
                        max-width: calc(100vw - 2rem) !important;
                        width: auto !important;
                        left: 0rem !important;
                        right: 1rem !important;
                        max-height: 200px !important;
                    }

                    .p-dropdown-panel:has(.p-dropdown-filter-container) {
                        max-height: 250px !important;
                    }

                    .p-dropdown-items-wrapper {
                        max-height: 150px !important;
                    }

                    .p-dropdown-panel:has(.p-dropdown-filter-container) .p-dropdown-items-wrapper {
                        max-height: 190px !important;
                    }

                    .p-dropdown-item {
                        padding: 0.625rem !important;
                        font-size: 14px !important;
                    }

                    .p-dropdown-filter {
                        font-size: 14px !important;
                        padding: 0.5rem 1.75rem 0.5rem 0.75rem !important;
                    }

                    .custom-dropdown-container .p-dropdown .p-dropdown-clear-icon {
                        font-size: 16px !important;
                        right: 2.5rem !important;
                    }
                }
            `}</style>

            <div className={`custom-dropdown-container relative w-full ${hasValue ? 'has-value' : ''}`}>
                <FloatLabel>
                    <DropdownP
                        id={id}
                        filter={filter}
                        filterBy={filterBy}
                        name={name}
                        value={normalizedValue}
                        onChange={onChange}
                        onBlur={onBlur}
                        options={options}
                        optionLabel={optionLabel}
                        optionValue={optionValue}
                        className={`w-full ${touched && error ? 'p-invalid' : ''} ${className}`}
                        showClear={showClear}
                        valueTemplate={valueTemplate}
                        itemTemplate={itemTemplate}
                        disabled={disabled}
                        filterPlaceholder="Ara..."
                        emptyMessage="Sonuç bulunamadı"
                        emptyFilterMessage="Filtre sonucu bulunamadı"
                        appendTo="self"
                        {...props}
                    />
                    <label htmlFor={id}>
                        {label} {required && <span className="text-red-500">*</span>}
                    </label>
                </FloatLabel>
                {touched && error && (
                    <small className="p-error">{error}</small>
                )}
            </div>
        </>
    );
};

export default Dropdown;